module.exports = __webpack_public_path__ + "static/img/zwydimg.eacdf6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/zwydimg.png
// module id = ezzd
// module chunks = 1